<script lang="ts">
  import type { ImageAsset } from '$lib/types/contentTypes';
  import SweatIcon from '../../../assets/svgs/sweat-icon.svelte';
  import Viewport from '$lib/components/utility/Viewport.svelte';
  export let title: string;
  export let description: string;
  export let image: ImageAsset;
  export let mobileImage: ImageAsset;
  export let link: string;
  export let programDuration: string;
  export let showNewProgramCallout: boolean;
  export let showChallengeCallout: boolean;
  export let horizontalSmallDevice: boolean = false;

  let width: number = 0;

  $: backgroundImageVars = `background-image: linear-gradient(178deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0) 50%, rgba(0,0,0,0.9) 100%), url(${image?.url}?w=600&q=85&fm=webp);`;
</script>

<Viewport bind:width />
{#if horizontalSmallDevice && width <= 1024}
  <a
    href={link}
    class="relative flex lg:grid grid-flow-row md:grid-flow-col gap-4 lg:grid-flow-row lg:grid-cols-[none] lg:gap-6 lg:rounded-lg"
  >
    <img
      src="{mobileImage?.url || image?.url}?w=600&q=85&fm=webp"
      alt={image.title}
      class="object-cover rounded-xxl h-[6.25rem] w-[8.875rem] lg:w-full lg:h-[15rem]"
    />
    {#if showNewProgramCallout}
      <div
        class="absolute top-0 left-0 m-2 py-[0.1rem] lg:py-0.5 px-2.5 w-[3.125rem] bg-primary-600 border border-primary-600 rounded-md"
      >
        <p class="text-white text-11 font-semibold text-center">NEW</p>
      </div>
    {/if}
    {#if showChallengeCallout}
      <div
        class="absolute top-0 left-0 m-2 p-[0.1rem] lg:p-0.5 w-[2.5rem] bg-primary-600 border border-primary-600 rounded-md"
      >
        <p class="text-white text-11 font-semibold text-center">💧🏆</p>
      </div>
    {/if}
    <div class="flex flex-col gap-0 justify-center lg:gap-2">
      <p class=" text-primary-500 font-semibold text-xs lg:text-sm">{programDuration}</p>
      <h3 class="text-gray-900 font-semibold text-normal lg:text-30">{title}</h3>
      {#if description.includes('undefined')}
        <p class="mt-1.5 text-gray-600 text-md font-medium"></p>
      {:else}
        <p class="mt-1.5 text-gray-600 text-md font-medium">{description}</p>
      {/if}
    </div>
  </a>
{:else}
  <a href={link} class="flex h-[32.5rem] w-full max-w-[20rem] lg:h-[38rem] lg:max-w-[24rem]">
    <div
      class="bg-center bg-no-repeat bg-cover border rounded-xl h-full w-full relative flex flex-col-reverse items-center"
      style={backgroundImageVars}
    >
      {#if showNewProgramCallout}
        <div
          class="absolute top-0 left-0 m-4 py-0.5 px-3 bg-primary-600 border border-primary-600 rounded-md"
        >
          <p class="text-white text-sm font-semibold">NEW</p>
        </div>
      {/if}
      {#if showChallengeCallout}
        <div
          class="absolute top-0 left-0 m-4 py-[0.1rem] px-2.5 w-[9.5rem] bg-primary-600 border border-primary-600 rounded-md"
        >
          <p class="text-white text-sm font-semibold text-center">SWEAT CHALLENGE</p>
        </div>
      {/if}
      <div class="w-full px-4 pb-12 text-center flex flex-col items-center">
        <SweatIcon />
        <p class="mt-3 text-white text-sm font-semibold">{programDuration}</p>
        <h3 class="mt-1.5 text-white text-30 font-semibold">{title}</h3>
        {#if description.includes('undefined')}
          <p class="mt-1.5 text-white text-md font-medium"></p>
        {:else}
          <p class="mt-1.5 text-white text-md font-medium">{description}</p>
        {/if}
      </div>
    </div>
  </a>
{/if}
